import React from 'react';
import AskNiwtcoBar from './components/AskNiwtcoBar';
import DataFreshnessChip from './components/DataFreshnessChip';
import NextDecisionsList from './components/NextDecisionsList';
import DraftsReadyPanel from './components/DraftsReadyPanel';
import EscalationsPanel from './components/EscalationsPanel';
import EngageANiwtPanel from './components/EngageANiwtPanel';
import { mockDecisions, mockDrafts, mockEscalations, mockAgents } from './mockData';

const Dashboard: React.FC = () => {
  return (
    <div className="-mx-4 sm:-mx-6 lg:-mx-8 -my-8">
      <AskNiwtcoBar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-12 gap-6">
          {/* Center column */}
          <div className="col-span-12 lg:col-span-8">
            <DataFreshnessChip />
            <NextDecisionsList decisions={mockDecisions} agents={mockAgents} />
          </div>

          {/* Right rail */}
          <aside className="col-span-12 lg:col-span-4 space-y-4">
            <DraftsReadyPanel drafts={mockDrafts} agents={mockAgents} />
            <EscalationsPanel escalations={mockEscalations} agents={mockAgents} />
            <EngageANiwtPanel agents={mockAgents} />
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
